import React from "react";
import "./Popup.css";

const Popup = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        {/* Close Button ❌ */}
        <span className="close-btn" onClick={onClose}>
          &times;
        </span>

        {/* Content */}
        {children}

      </div>
    </div>
  );
};

export default Popup;